import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  createNewInvoice: 'Create a new Invoice',
  plusInvoice: '+ Invoice',
})
